import Services from '../components/website/Services/Services'
import Layout from '../layouts/Layout'
import { Helmet } from 'react-helmet';
import { Link } from 'gatsby';
import config from '../website-config';
const url = typeof window !== 'undefined' ? window.location.href : '';
const ServicesPage = () => (
    <Layout>
       <Helmet>
       <title>Services - Premium Wordpress and Web Development</title>
        <meta name="description" content='Best Wordpress and Web Development in Delhi , Premium Websites' />
        <meta name="keywords" content={`${config.keyword}`}/>
        <meta property="og:type" content="website" />
        <meta property="og:title" content='Our Services - Wordpress and Web Development Services' />
        <meta property="og:description" content='Leading Wordpress and Web Development Company in Delhi' />
        <meta property="og:url" content='https://bizdamn.tech/services' />
        <meta property="og:image:width"  />
        <meta property="og:image:height" />
        <script type="application/ld+json">
        {`
         {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://bizdamn.tech/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Services",
              "item": "https://bizdamn.tech/services"
            }]
          },
          {
            "@context": "https://schema.org/",
            "@type": "WebPage",
            "name": "Wordpress and Custom Web Development Services",
            "speakable":
            {
             "@type": "SpeakableSpecification",
             "xPath": [
               "/html/head/title",
               "/html/head/meta[@name='description']/@content"
               ]
             },
            "url": ${url}
            },
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [{
                "@type": "Question",
                "name": " What are Types of Wordpress Websites?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": " <ul>
                  <Link to='/website-packages'> <li>Ecommerce Website</li></Link>
                  <Link to='/website-packages'> <li>Business Website</li></Link>
                  <Link to='/website-packages'> <li>Blog or Personal Website</li></Link>
                  <Link to='/website-packages'> <li>Portfolio Website</li></Link>
                  <Link to='/website-packages'> <li>Book Launch Website</li></Link>
                </ul>"
                }
              }, {
                "@type": "Question",
                "name": " How much time does WordPress website development take?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": " There is no accurate answer,it depends on the type of website which you want to develop.
                  <br /><br />
                  Ecommerce WordPress website can take 17-20 days.
                  <br /><br />
                  A Buusiness WordPress website will take 6-8 days."
                }
              }, {
                "@type": "Question",
                "name": "How will I get regular updates on my wordpress development project?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": " Our Project Delivery manager will remain in direct touch with you to provide regular updates on the progress of the project.
                  <br /><br />
                  You can opt for any medium of communication with us.
                  <br /><br />
                  You will be provided a temporary link to see your project progress and details at any time😊"
                }
              }, {
                "@type": "Question",
                "name": "How much does WordPress website development cost?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "You can cheack all <Link to='/website-packages'>Our Pacakges Here</Link>"
                }
              }, {
                "@type": "Question",
                "name": "  Will my website be optimized for search engines like Google?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text":" Be it a start-up or scale-up, enterprise or corporate website, our designs are compliant with SEO guidelines. <br />
                  Let us know and we will be happy to explain the details."}
                }]
            }
              }, {
                "@type": "Question",
                "name": "How does the Web Development Process work?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text":"  Here’s a run-down of the phases involved in our web development process:
                  <ul>
                    <li>Consultation & Requirement Gathering</li>
                    <li>Establish a Project Plan</li>
                    <li>Design of Website Mock-ups</li>
                    <li>Create Site Architecture and Database</li>
                    <li>Website Building</li>
                    <li>Website Testing & Launch</li>
                    <li>Support & Maintenance</li>
                  </ul>"}
                }]
              }, {
                "@type": "Question",
                "name": " I have aready finalized my website design(Mockup).Can you Build?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text":"Yes sure, we will love to follow your Designs"}
                }]
            }
              }, {
                "@type": "Question",
                "name": "  What is Website Maintenance?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text":"  Regularly checking your Website for mistakes & issues in order to keep ir releavent and updated.<br />
                  This needs to be done on a consistent basis to keep your website healthy, strengthen your SEO as well as Google Ranking and encourage the continued growth of traffic."}
                }]
            }
              }, {
                "@type": "Question",
                "name": "Why Website Maintenance services is Necessary?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text":" <ul>
                  <li>To keep your Website Running</li>
                  <li>To acquire new customers</li>
                  <li>To maintain your credibility</li>
                  <li>To get higher search engine rankings</li>
                </ul>"}
                }]
            }
          `}
            </script>
      </Helmet>
    {/* Breadcrumbs */}
    <section className="breadcrumbs">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <ol>
            <li><Link to='/'>Home</Link></li>
            <li>Services</li>
          </ol>
        </div>
      </div>
    </section>
      <Services />
    </Layout>
  )

export default ServicesPage